export default "__VITE_ASSET__IS2d3H6W__"